import { render, staticRenderFns } from "./database.vue?vue&type=template&id=eb97ff50"
import script from "./database.vue?vue&type=script&lang=js"
export * from "./database.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports